module.exports = Em.Component.extend({
    classNames: ['additional-info-list-item'],

    classNameBindings: ['item.dropdownIsVisible:is-open'],

    item: null,

    annualReport: Em.inject.service(),

    _openDropdown: function() {
        var contentHeight = this.$('.collapse-body-inner').css('height')

        this.set('item.dropdownIsVisible', true)
        this.$('.collapse-body').css({
            height: contentHeight
        })
    },

    _closeDropdown: function() {
        this.set('item.dropdownIsVisible', false)
        this.$().removeClass('disable-transition')
        this.$('.collapse-body').css({
            height: 0
        })
    },

    _resetChoiceState: function() {
        this.get('item.choices').forEach(function(value) {
            value.set('isSelected', false)
        })
    },

    _resetSubSectionChoiceState: function(field) {
        Em.get(field, 'choices').forEach(function(choice) {
            Em.set(choice, 'isSelected', false)
        })
    },

    actions: {
        didClickSubSection: function(choice, field) {
            var self = this
            var item = this.get('item')

            var answer = {
                name: field.name,
                value: choice.get('value')
            }

            // Finds previous selected choice
            var prevChoice = Em.get(field, 'choices').find(function(value) {
                return value.get('isSelected')
            })

            // Toggle isSelected class on choices
            this._resetSubSectionChoiceState(field)
            choice.set('isSelected', true)

            Em.set(field, 'isValid', true)

            this.get('annualReport').putAnswer(item.year, [answer])
                .catch(function() {
                    // Reset UI state if not answered before
                    if (self.get('item.createdTime') === null) {
                        self._resetSubSectionChoiceState(field)
                        Em.set(field, 'isValid', false)
                    // Only change UI if another choice is selected
                    } else if (prevChoice && (choice.value !== prevChoice.value)) {
                        choice.set('isSelected', false)
                        prevChoice && prevChoice.set('isSelected', true)
                    }
                })
        }
    }
})
